import { apiClient } from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) output[i] = rawData.charCodeAt(i);
  return output;
}

export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export async function registerServiceWorker() {
  if (!isPushSupported()) return null;
  try {
    const reg = await navigator.serviceWorker.register('/service-worker.js');
    await navigator.serviceWorker.ready;
    return reg;
  } catch (err) {
    console.warn('SW register failed:', err);
    return null;
  }
}

export async function subscribeToPush() {
  if (!isPushSupported()) return { ok: false, reason: 'unsupported' };

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return { ok: false, reason: 'denied' };

  const reg = await registerServiceWorker();
  if (!reg) return { ok: false, reason: 'sw-failed' };

  const existing = await reg.pushManager.getSubscription();
  if (existing) {
    try {
      await apiClient.post('/push/subscribe', { subscription: existing.toJSON() });
    } catch (e) {}
    return { ok: true, subscription: existing };
  }

  const { data } = await apiClient.get('/push/vapid-public-key');
  if (!data.public_key) return { ok: false, reason: 'no-vapid' };

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });

  await apiClient.post('/push/subscribe', { subscription: sub.toJSON() });
  return { ok: true, subscription: sub };
}

export async function unsubscribeFromPush() {
  if (!isPushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try {
    await apiClient.delete('/push/unsubscribe', { data: { endpoint: sub.endpoint } });
  } catch (e) {}
  await sub.unsubscribe();
}
